import axios from "axios";

function getBaseURL() {
  const isCloud = window.location.hostname.includes("pages.dev");
  const isLocalDev = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  const isLocalNetwork =
    window.location.hostname.startsWith("192.168.") ||
    window.location.hostname.startsWith("10.") ||
    window.location.hostname.startsWith("172.");

  if (isCloud) return "https://snhotel-pos-backend-1.onrender.com/api";
  if (isLocalNetwork) return `http://${window.location.hostname}:8080/api`;
  if (isLocalDev) return "http://localhost:8080/api";

  return "https://snhotel-pos-backend-1.onrender.com/api";
}

// Live switcher logic
async function detectAPI() {
  const cloudURL = "https://snhotel-pos-backend-1.onrender.com/api";
  const localURL = `http://${window.location.hostname}:8080/api`;

  try {
    const cloudCheck = await fetch(`${cloudURL}/health`);
    if (cloudCheck.ok) {
      localStorage.setItem("API_BASE", cloudURL);
      return cloudURL;
    }
  } catch {}

  // online failed, fallback to local
  localStorage.setItem("API_BASE", localURL);
  return localURL;
}

const defaultURL = getBaseURL();
const savedURL = localStorage.getItem("API_BASE") || defaultURL;

const api = axios.create({
  baseURL: savedURL,
});

// Auto-switch every 7 seconds
setInterval(async () => {
  const current = localStorage.getItem("API_BASE");
  const newURL = await detectAPI();

  if (newURL !== current) {
    console.log("🔄 Backend changed:", newURL);
    window.location.reload();
  }
}, 7000);

// Token attach
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
